import type React from 'react';

export interface SidebarIconProps {
	width?: string | number;
	height?: string | number;
	color?: string;
	'aria-label'?: string;
}

const SidebarIcon: React.FC<SidebarIconProps> = ({
	width = 21,
	height = 14,
	color = 'currentColor',
	'aria-label': ariaLabel = 'Sidebar Icon',
}) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 21 14"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-label={ariaLabel}
		style={{ color }}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M0 2.33333V0H21V2.33333H0ZM0 8.16667H21V5.83333H0V8.16667ZM0 14H21V11.6667H0V14Z"
			fill="currentColor"
		/>
	</svg>
);

export default SidebarIcon;
